import { useTranslation } from 'react-i18next';
import { UserAuthForm } from './components/user-auth-form';
import { Scale, Verified } from 'lucide-react';
import { LanguageSwitcher } from '@/components/language-switcher';

export default function SignIn() {
  const { t } = useTranslation();

  return (
    <div className="relative min-h-screen flex flex-col items-center justify-center p-4 overflow-hidden bg-gray-50 dark:bg-slate-950 text-gray-800 dark:text-gray-100 transition-colors duration-200">
      {/* Language Switcher */}
      <div className='absolute top-4 right-4 z-10'>
        <LanguageSwitcher variant='outline' size='default' />
      </div>
      {/* Background Blobs */}
      <div className="absolute top-0 left-0 w-full h-full overflow-hidden -z-10 pointer-events-none">
        <div className="absolute -top-[20%] -right-[10%] w-[50%] h-[50%] bg-primary/10 rounded-full blur-3xl" />
        <div className="absolute top-[40%] -left-[10%] w-[40%] h-[40%] bg-secondary/10 rounded-full blur-3xl" />
      </div>

      {/* Main Card */}
      <div className="w-full max-w-sm md:max-w-md bg-white dark:bg-slate-900 rounded-3xl shadow-2xl border border-gray-100 dark:border-gray-800 overflow-hidden relative">
        <div className="h-2 w-full bg-gradient-to-r from-primary to-primary-dark" />

        <div className="p-8 pt-10">
          {/* Header Section */}
          <div className="text-center mb-10">
            <div className="inline-flex items-center justify-center w-16 h-16 rounded-2xl bg-blue-50 dark:bg-blue-900/20 mb-4 text-primary dark:text-blue-300 shadow-sm">
              <Scale className="w-8 h-8" />
            </div>
            <h1 className="text-3xl font-extrabold tracking-wide text-primary dark:text-white mb-2 font-display">
              Avocat<span className="text-secondary">Pro</span>
            </h1>
            <p className="text-gray-500 dark:text-gray-400 text-sm">
              {t('log_ins')}
            </p>
          </div>

          {/* Form Section */}
          <UserAuthForm />

        </div>

        {/* Footer Section */}
        <div className="bg-gray-50 dark:bg-gray-800/50 p-4 border-t border-gray-100 dark:border-gray-700 text-center">
          <p className="text-[10px] text-gray-400 dark:text-gray-500 leading-relaxed max-w-xs mx-auto">
            <span dangerouslySetInnerHTML={{
              __html: t('tos').replace(
                t('privacy_policy'),
                `<a href="/privacy-policy.html" class="underline hover:text-primary dark:hover:text-gray-300" target="_blank" rel="noopener noreferrer">${t('privacy_policy')}</a>`
              )
            }} />
          </p>
        </div>
      </div>

      {/* Secured By Badge */}
      <div className="mt-8 text-gray-400 text-xs flex items-center gap-1 opacity-60">
        <Verified className="w-4 h-4" />
        <span>Secured by AvocatPro Systems</span>
      </div>
    </div>
  );
}
